export const TYPES = {
  OPEN_REVIEW_SHORT_OFFCANVAS: "OPEN_REVIEW_SHORT_OFFCANVAS",
  CLOSE_REVIEW_SHORT_OFFCANVAS: "CLOSE_REVIEW_SHORT_OFFCANVAS",
  MOVE_TO_NEXT_CLOSET_ITEM_REVIEW: "MOVE_TO_NEXT_CLOSET_ITEM_REVIEW",
};

export function openReviewShortOffcanvas(closet) {
  return async (dispatch) => {
    dispatch({ type: TYPES.OPEN_REVIEW_SHORT_OFFCANVAS, closet });
  };
}

export function closeReviewShortOffcanvas() {
  return async (dispatch) => {
    dispatch({ type: TYPES.CLOSE_REVIEW_SHORT_OFFCANVAS });
  };
}

export function moveToNextClosetItemReview(closetItem) {
  return async (dispatch) => {
    dispatch({ type: TYPES.MOVE_TO_NEXT_CLOSET_ITEM_REVIEW, closetItem });
  };
}
